var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 33,
    viewBox: "0 0 20 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2507 1.91602H13.8757C11.9418 1.91602 10.0871 2.68424 8.71966 4.0517C7.35221 5.41915 6.58398 7.27381 6.58398 9.20768V13.5827H2.20898V19.416H6.58398V31.0827H12.4173V19.416H16.7923L18.2507 13.5827H12.4173V9.20768C12.4173 8.82091 12.571 8.44998 12.8445 8.17648C13.1179 7.90299 13.4889 7.74935 13.8757 7.74935H18.2507V1.91602Z",
    stroke: "#0073FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.48d5f493a80c4ec8ec0112e6d4bf70de.svg";
export { ForwardRef as ReactComponent };